/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightObservedSegment
 */
export interface FlightObservedSegment {
    /**
     *
     * @type {string}
     * @memberof FlightObservedSegment
     */
    origin: string;
    /**
     *
     * @type {string}
     * @memberof FlightObservedSegment
     */
    destination: string;
    /**
     * Origin airport local departure calendar date (YYYY-MM-DD), preserved independently of the departing_at timestamp and its UTC serialization.
     * @type {string}
     * @memberof FlightObservedSegment
     */
    departureDate: string;
    /**
     *
     * @type {Date}
     * @memberof FlightObservedSegment
     */
    departingAt: Date;
    /**
     *
     * @type {Date}
     * @memberof FlightObservedSegment
     */
    arrivingAt: Date;
    /**
     *
     * @type {number}
     * @memberof FlightObservedSegment
     */
    sliceIndex: number;
    /**
     *
     * @type {string}
     * @memberof FlightObservedSegment
     */
    marketingCarrier?: string | null;
    /**
     *
     * @type {string}
     * @memberof FlightObservedSegment
     */
    marketingFlightNumber?: string | null;
    /**
     *
     * @type {Set<string>}
     * @memberof FlightObservedSegment
     */
    marketingFlightIdentities?: Set<string>;
    /**
     *
     * @type {string}
     * @memberof FlightObservedSegment
     */
    operatingCarrier?: string | null;
    /**
     *
     * @type {string}
     * @memberof FlightObservedSegment
     */
    operatingFlightNumber?: string | null;
    /**
     *
     * @type {string}
     * @memberof FlightObservedSegment
     */
    cabin?: string | null;
    /**
     *
     * @type {string}
     * @memberof FlightObservedSegment
     */
    cabinMarketingName?: string | null;
    /**
     *
     * @type {string}
     * @memberof FlightObservedSegment
     */
    bookingClass?: string | null;
    /**
     *
     * @type {string}
     * @memberof FlightObservedSegment
     */
    fareBasisCode?: string | null;
}

/**
 * Check if a given object implements the FlightObservedSegment interface.
 */
export function instanceOfFlightObservedSegment(value: object): value is FlightObservedSegment {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('destination' in value) || value['destination'] === undefined) return false;
    if (!('departureDate' in value) || value['departureDate'] === undefined) return false;
    if (!('departingAt' in value) || value['departingAt'] === undefined) return false;
    if (!('arrivingAt' in value) || value['arrivingAt'] === undefined) return false;
    if (!('sliceIndex' in value) || value['sliceIndex'] === undefined) return false;
    return true;
}

export function FlightObservedSegmentFromJSON(json: any): FlightObservedSegment {
    return FlightObservedSegmentFromJSONTyped(json, false);
}

export function FlightObservedSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightObservedSegment {
    if (json == null) {
        return json;
    }
    return {

        'origin': json['origin'],
        'destination': json['destination'],
        'departureDate': json['departure_date'],
        'departingAt': (new Date(json['departing_at'])),
        'arrivingAt': (new Date(json['arriving_at'])),
        'sliceIndex': json['slice_index'],
        'marketingCarrier': json['marketing_carrier'] == null ? undefined : json['marketing_carrier'],
        'marketingFlightNumber': json['marketing_flight_number'] == null ? undefined : json['marketing_flight_number'],
        'marketingFlightIdentities': json['marketing_flight_identities'] == null ? undefined : new Set(json['marketing_flight_identities']),
        'operatingCarrier': json['operating_carrier'] == null ? undefined : json['operating_carrier'],
        'operatingFlightNumber': json['operating_flight_number'] == null ? undefined : json['operating_flight_number'],
        'cabin': json['cabin'] == null ? undefined : json['cabin'],
        'cabinMarketingName': json['cabin_marketing_name'] == null ? undefined : json['cabin_marketing_name'],
        'bookingClass': json['booking_class'] == null ? undefined : json['booking_class'],
        'fareBasisCode': json['fare_basis_code'] == null ? undefined : json['fare_basis_code'],
    };
}

export function FlightObservedSegmentToJSON(json: any): FlightObservedSegment {
    return FlightObservedSegmentToJSONTyped(json, false);
}

export function FlightObservedSegmentToJSONTyped(value?: FlightObservedSegment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'origin': value['origin'],
        'destination': value['destination'],
        'departure_date': value['departureDate'],
        'departing_at': value['departingAt'].toISOString(),
        'arriving_at': value['arrivingAt'].toISOString(),
        'slice_index': value['sliceIndex'],
        'marketing_carrier': value['marketingCarrier'],
        'marketing_flight_number': value['marketingFlightNumber'],
        'marketing_flight_identities': value['marketingFlightIdentities'] == null ? undefined : Array.from(value['marketingFlightIdentities'] as Set<any>),
        'operating_carrier': value['operatingCarrier'],
        'operating_flight_number': value['operatingFlightNumber'],
        'cabin': value['cabin'],
        'cabin_marketing_name': value['cabinMarketingName'],
        'booking_class': value['bookingClass'],
        'fare_basis_code': value['fareBasisCode'],
    };
}
